import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconWrite: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"write, edit-list, list"} maskId="square-filled-radius-0-stroke-1-IconWrite"><path d="M21 3H3V4H21V3Z" fill="currentColor"/><path d="M17.3407 6.7666L22.2362 11.6621L11.8798 22.0184H6.98438V17.123L17.3407 6.7666Z" fill="currentColor"/><path d="M3 7H11V8H3V7Z" fill="currentColor"/><path d="M8.0022 11H3V12H8.0022V11Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconWrite;
